import React, { useState } from 'react';

import './accordion-list.scss';


/**
 * 
 * Shows a tree structured data. 
 * 
 * @param {object} props
 * @param {string} props.idkey - The unique id which is used to highlight/ select items in the list
 * @param {string} props.colkeys -  The columns key object for which the columns, their title and their content is created
 * @param {function} props.rowOnClick -  The function which should be triggered when a row is clicked on
 * @param {Array<Object>} props.data -  The array of items which should be shown in the list
 *
 * @param {string} props.children - The key in an item which indicated the children items. The children items can have a different column keys object.
 * @param {object} props.childColKeys -  The columns keys object for the children objects. if provided, all children will use this columns key object
 *
 * @param {string} props.className -  The style class name of the the whole list. Controls the size of the font etc.
 */
export default function AccordionList({ data, ...props }) {
    const idkey = props.idkey !== undefined ? props.idkey : 'id';

    return (
        <div className="accordion-list">
            <div className="accordion-list-header">
                <div className="columns">
                    {props.colkeys.map(col => (
                        <div className={`${col.className}`} key={`header-${col.key}`}>
                            {col.title}
                        </div>
                    ))}
                </div>
            </div>
            {data !== undefined && Array.isArray(data) && data.map(item => (item ? <AccordionListItem item={item} key={item[idkey]} {...props} /> : null))}
        </div>
    );
}

function AccordionListItem({ colkeys, item, highlightId, rowOnClick, ...props }) {
    const [childrenVisible, setChildrenVisible] = useState(false);

    const columnKeys = colkeys ? (Array.isArray(colkeys) ? colkeys : typeof colkeys === 'string' ? [colkeys] : []) : [];
    const idkey = props.idkey ? props.idkey : 'id';
    let isHighlighted = highlightId && Array.isArray(props.highlightId) ? highlightId.includes(item[idkey]) : item[idkey] === props.highlightId;

    const childKey =
        props && item && props.childkey && item[props.childkey] && Array.isArray(item[props.childkey]) && item[props.childkey].length > 0
            ? props.childkey
            : null;

    const childColKeys = props && item && props.childColKeys ? props.childColKeys : colkeys;

    function toggleChildren() {
        if (childKey) {
            setChildrenVisible(prev => !prev);
        }
    }

    return (
        <div
            className={`accordion-list-item ${isHighlighted ? 'highlight' : ''} ${childKey !== null ? 'has-children' : ''} ${
                childrenVisible ? 'children-open' : ''
            }`}>
            <div className="columns">
                {columnKeys.map((col, ind) => {
                    const key = col.key;

                    const value =
                        col.content !== undefined && typeof col.content === 'function'
                            ? col.content(item)
                            : key !== null
                            ? item[key] !== undefined
                            ? Array.isArray(item[key])
                            ? item[key].join(', ')
                                : item[key]
                                : '-'
                            : null;

                    return (
                        <div
                            className={`accordion-list-item-column ${col.className}`}
                            key={ind}
                            onClick={() => (col.onClickOpenChildren ? toggleChildren() : col.onClickEditRow ? rowOnClick(item) : null)}>
                            {value !== null && value}
                            {value === null && col.content !== undefined && typeof col.content === 'function' && col.content(item)}
                            {value === null && col.content !== undefined && typeof col.content === 'string' && col.content}
                        </div>
                    );
                })}
            </div>
            {childKey !== null && childrenVisible && (
                <div className="accordion-list-item-children">
                    {item[childKey].map((childItem, ind) => {
                        return (
                            <AccordionListItem
                                item={childItem}
                                key={`item-${childItem[idkey]}`}
                                // key={`item-${ind}`}
                                colkeys={childColKeys}
                                rowOnClick={rowOnClick}
                                {...props}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
}
